import type { Strapi5Error } from '@nuxtjs/strapi';
import type { FetchOptions } from 'ofetch';

interface Options extends FetchOptions {
  cacheKey?: string;
  cacheMaxAge?: number;
}

export default async function apiClient<T>(
  path: string,
  options: Options = {},
) {
  const response = await $fetch<T & { error?: Strapi5Error }>('/api' + path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      ...options,
      retry: 0,
    },
    retry: 0,
  });

  if (response && response.error) {
    throw response;
  }
  return response;
}
